import image0 from '../assets/record-cards/total-score.webp';
import locked0 from '../assets/record-cards/total-score-locked.webp';
import image1 from '../assets/record-cards/total-repeats.webp';
import locked1 from '../assets/record-cards/total-repeats-locked.webp';
import image2 from '../assets/record-cards/total-time.webp';
import locked2 from '../assets/record-cards/total-time-locked.webp';
import image3 from '../assets/record-cards/total-days.webp';
import locked3 from '../assets/record-cards/total-days-locked.webp';
import image4 from '../assets/record-cards/best-streak.webp';
import locked4 from '../assets/record-cards/best-streak-locked.webp';
import image5 from '../assets/record-cards/best-day-score.webp';
import locked5 from '../assets/record-cards/best-day-score-locked.webp';
import image6 from '../assets/record-cards/best-day-time.webp';
import locked6 from '../assets/record-cards/best-day-time-locked.webp';
import image7 from '../assets/record-cards/tournament-score.webp';
import locked7 from '../assets/record-cards/tournament-score-locked.webp';
import image8 from '../assets/record-cards/tournament-round.webp';
import locked8 from '../assets/record-cards/tournament-round-locked.webp';
import image9 from '../assets/record-cards/tournament-entries.webp';
import locked9 from '../assets/record-cards/tournament-entries-locked.webp';
import image10 from '../assets/record-cards/tournament-win-rate.webp';
import locked10 from '../assets/record-cards/tournament-win-rate-locked.webp';
import image11 from '../assets/record-cards/card-upgrades.webp';
import locked11 from '../assets/record-cards/card-upgrades-locked.webp';
import image12 from '../assets/record-cards/market-uploads.webp';
import locked12 from '../assets/record-cards/market-uploads-locked.webp';
import image13 from '../assets/record-cards/listening-time.webp';
import locked13 from '../assets/record-cards/listening-time-locked.webp';
import image14 from '../assets/record-cards/milestone-level-100.webp';
import locked14 from '../assets/record-cards/milestone-level-100-locked.webp';
import image15 from '../assets/record-cards/milestone-sentences-1000.webp';
import locked15 from '../assets/record-cards/milestone-sentences-1000-locked.webp';
import image16 from '../assets/record-cards/milestone-membership-year.webp';
import locked16 from '../assets/record-cards/milestone-membership-year-locked.webp';

const lockedArtwork = new Map([
  [image0, locked0],
  [image1, locked1],
  [image2, locked2],
  [image3, locked3],
  [image4, locked4],
  [image5, locked5],
  [image6, locked6],
  [image7, locked7],
  [image8, locked8],
  [image9, locked9],
  [image10, locked10],
  [image11, locked11],
  [image12, locked12],
  [image13, locked13],
  [image14, locked14],
  [image15, locked15],
  [image16, locked16],
]);

export const getLockedRecordArtwork = (artwork) => lockedArtwork.get(artwork);
export const additionalRecordArtwork = Object.freeze({
  cardUpgrades: image11,
  marketUploads: image12,
  listeningTime: image13,
  level100: image14,
  graduation1000: image15,
  membershipYear: image16,
});
